import {HttpClient, HttpErrorResponse, HttpParams} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';

import {Observable, of, throwError} from 'rxjs';
import {catchError, delay, mergeMap, retryWhen, switchMap} from 'rxjs/operators';
import {DOCUMENT} from '@angular/common';
import {NbToastrService} from '@nebular/theme';
import {environment} from '@environments/environment';

export interface HttpResponse<T> {
    data: T;
    message: string;
    success: boolean;
}

@Injectable({providedIn: 'root'}) /** сервис обработки запросов к api */
export class FetcherService {

    readonly payloadMethods: string[] = ['post', 'put'];
    readonly baseUrl = environment.api;
    private requests: object = {};

    constructor(private http: HttpClient,
                private toastr: NbToastrService,
                @Inject(DOCUMENT) private document) {
    }


    get<R>(url: string, p: any = {}, ids?: any, options: any = {}): Observable<R> {
        if (ids) {
            Object.keys(ids).forEach(key => {
                url = url.replace(`{${key}}`, ids[key]);
            });
        }
        let params = new HttpParams();
        for (const key of Object.keys(p)) {
            if (p[key] != null) {
                params = params.append(key, p[key]);
            }
        }
        return this.request('get', url, {params, ...options}, null, p?.timeoutMs);
    }

    post<R>(url: string, data?: any, ids?: any, options: any = {}): Observable<R> {
        if (ids) {
            Object.keys(ids).forEach(key => {
                url = url.replace(`{${key}}`, ids[key]);
            });
        }
        return this.request('post', url, options, data, options?.timeoutMs);
    }

    put<R>(url: string, data: any, ids?: any, options: any = {}): Observable<R> {
        if (ids) {
            Object.keys(ids).forEach(key => {
                url = url.replace(`{${key}}`, ids[key]);
            });
        }
        return this.request('put', url, options, data, options?.timeoutMs);
    }

    delete<R>(url: string, ids?: any, options: any = {}, p = {}): Observable<R> {
        if (ids) {
            Object.keys(ids).forEach(key => {
                url = url.replace(`{${key}}`, ids[key]);
            });
        }
        let params = new HttpParams();
        for (const key of Object.keys(p)) {
            if (p[key] != null) {
                params = params.append(key, p[key]);
            }
        }
        return this.request('delete', url, {params, ...options}, null, options?.timeoutMs);
    }

    createFormData(form) {
        const formData: FormData = new FormData();
        Object.keys(form)
            .forEach((item: string) => {
                if (form[item] !== null && typeof form[item] !== 'undefined') {
                    formData.append(item, form[item]);
                }
            });
        return formData;
    }

    private request<R>(method: string, url: string, options: any, data?: any, timeoutMs = 1000 * 60 * 5): Observable<R> {
        const key: string = [method, url, options?.params ? options?.params.toString() : 'empty'].join('::');
        let request: Observable<any>;
        if (this.payloadMethods.includes(method)) {
            request = this.http[method](`${this.baseUrl}${url}`, data, options);
        } else {
            request = this.http[method](`${this.baseUrl}${url}`, options);
        }
        options.withCredentials = true;
        let retries = 0;
        const slotTime = 1000;
        let backoff = 1000;
        const start = performance.now();
        return this.requests[key] = request
            .pipe(
                retryWhen((errors: Observable<any>) => errors.pipe(
                    delay(Math.min(backoff, 10 * 1000)),
                    mergeMap(error => {
                            if (error.status === 409) {
                                backoff = slotTime + Math.pow(1.5, retries++);
                                const isLastAttempt = performance.now() > start + timeoutMs;
                                return !isLastAttempt ? of(error) : throwError(error.status);
                            } else {
                                return throwError(error);
                            }
                        }
                    ))
                ),
                switchMap((response: HttpResponse<R>) => {
                    if (response?.success) {
                        return of(response.data);
                    } else {
                        throw {error: response.message};
                    }
                }),
                catchError((response: HttpErrorResponse | any) => {
                    if (options.noError) {
                        return of(response);
                    }
                    if (typeof response === 'number') {
                        if (response === 409) {
                            console.error(`Tried to load Resource over XHR for ${retries} times without success. Giving up`);
                        }
                    }
                    if (![404, 405].includes(response.status) && typeof response.error === 'string') {
                        this.toastr.danger(response.error, 'Ошибка');

                    } else if (response.status === 422) {
                        Object.keys(response.error.errors).forEach(k => this.toastr.danger(response.error.errors[k][0], 'Ошибка'));

                    } else {

                        return throwError(response);
                    }
                    console.log(window.location.search);
                    return throwError(response);
                })
            );
    }

}
